import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader';
import Wrapper from '../../components/Wrapper';
import {useTranslation} from '../../hooks/useTranslation';
import './index.scss';
import {useDispatch} from 'react-redux';
import {NavLink, useNavigate, useParams} from 'react-router-dom';
import {
  useAgencyWaterTestKitTypesQuery,
  useCanAddFacilityMutation,
  useCancelSubscriptionMutation,
  useGetAgencyQuery,
  useGetTimezonesQuery,
  useGetUsersRolesQuery,
  useLazyGetAgencyByIdQuery,
  useLazyGetFacilityByAgencyQuery,
  useLazyGetOrdersListFboQuery,
  useLazyGetSubscriptionsFboQuery,
  useLazyGetUsersQuery,
} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import {useErrorHandler} from '../../global/ErrorsHandler';
import moment from 'moment/moment';
import ManagementRow from '../../components/ManagementRow';
import Modal from '../../components/Modal';
import Cropper from 'react-cropper';
import CustomPaginate from '../../components/PaginateComponent';
import Checkbox from '../../components/Checkbox';

const AgencyDetail = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [dangerShow, setDangerShow] = useState(false);
  const [currentTab, setCurrentTab] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [createModalStatus, setCreateModalStatus] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [imageBlob, setImageBlob] = useState(null);
  const [chosenPhoto, setChosenPhoto] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cropper, setCropper] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [canAdd, setCanAdd] = useState(false);
  const [userList, setUserList] = useState([]);
  const [trigerGetUsers, setTrigerGetUsers] = useState(false);
  const [
    getAgency,
    {
      data: agencyData,
      error: agencyError,
      isLoading: agencyIsLoading,
      isSuccess: agencyIsSuccess,
      isError: agencyIsError,
    },
  ] = useLazyGetAgencyByIdQuery();
  const {
    data: userRolesData,
    isSuccess: userRolesIsSuccess,
    isLoading: userRolesIsLoading,
    isError: userRolesIsError,
    error: userRolesError,
  } = useGetUsersRolesQuery();
  const [
    getFacilityByAgencyId,
    {
      data: getFacilityByAgencyIdIdData,
      error: getFacilityByAgencyIdError,
      isLoading: getFacilityByAgencyIdIsLoading,
      isSuccess: getFacilityByAgencyIdIsSuccess,
      isError: getFacilityByAgencyIdIsError,
    },
  ] = useLazyGetFacilityByAgencyQuery();

  const [
    cancelSubscription,
    {
      data: cancelSubscriptionData,
      error: cancelSubscriptionError,
      isFetching: cancelSubscriptionIsLoading,
      isSuccess: cancelSubscriptionIsSuccess,
      isError: cancelSubscriptionIsError,
    },
  ] = useCancelSubscriptionMutation();

  const [
    getUsers,
    {
      data: getUsersData,
      error: getUsersError,
      isLoading: getUsersIsLoading,
      isSuccess: getUsersIsSuccess,
      isError: getUsersIsError,
    },
  ] = useLazyGetUsersQuery();

  const [
    getOrders,
    {
      data: getOrdersData,
      error: getOrdersError,
      isLoading: getOrdersIsLoading,
      isSuccess: getOrdersIsSuccess,
      isError: getOrdersIsError,
    },
  ] = useLazyGetOrdersListFboQuery();

  const [
    getSubs,
    {
      data: getSubsData,
      error: getSubsError,
      isLoading: getSubsIsLoading,
      isSuccess: getSubsIsSuccess,
      isError: getSubsIsError,
    },
  ] = useLazyGetSubscriptionsFboQuery();

  const {
    data: timezonesData,
    error: timezonesError,
    isLoading: timezonesIsLoading,
    isSuccess: timezonesIsSuccess,
    isError: timezonesIsError,
  } = useGetTimezonesQuery();
  const {data, isLoading, isSuccess, isError} = useGetAgencyQuery();
  const [
    canAddAction,
    {
      data: setCanAddData,
      error: setCanAddError,
      isLoading: setCanAddIsLoading,
      isSuccess: setCanAddIsSuccess,
      isError: setCanAddIsError,
    },
  ] = useCanAddFacilityMutation();
  const [errorHandler, setErrorHandler] = useErrorHandler([
    cancelSubscriptionError,
    setCanAddError,
  ]);
  const {
    data: waterKitData,
    error: waterKitError,
    isLoading: waterKitIsLoading,
    isSuccess: waterKitIsSuccess,
    isError: waterKitIsError,
  } = useAgencyWaterTestKitTypesQuery();

  useEffect(() => {
    getAgency(params.id);
  }, [params,createModalStatus]);

  useEffect(() => {
    getFacilityByAgencyId({id: params.id, page: 1});
  }, [agencyData]);

  useEffect(() => {
    if (agencyIsSuccess) {
      setCanAdd(agencyData?.data?.is_able_to_add_facility_trial);
    }
    if (getUsersData?.length > 0) {
      setUserList(getUsersData?.map(user => ({...user, action_status: false})));
    }
  }, [agencyIsSuccess, getUsersData]);

  useEffect(() => {
    if (setCanAddIsSuccess) {
      toast.success(t('agencyDetail.messages.successfullyChanged'));
    }
    if (setCanAddIsError) {
      toast.error(t('agencyDetail.messages.somethingWentWrong'));
    }
  }, [setCanAddIsSuccess, setCanAddIsError]);

  const getTrigerUsers = () => {
    getAgency(params.id);
    getUsers(params.id);
  };

  useEffect(() => {
    if (currentTab == 0) {
      getUsers(params.id);
    }
    if (currentTab == 1) {
      getSubs({id: params.id, page: currentPage});
    }
    if (currentTab == 2) {
      getFacilityByAgencyId({id: params.id, page: currentPage});
    }
    if (currentTab == 3) {
      getOrders({id: params.id, page: currentPage});
    }
  }, [currentTab, currentPage, trigerGetUsers]);

  useEffect(() => {
    if (agencyIsLoading || setCanAddIsLoading) {
      dispatch(setLoader(true));
    }
    if (agencyIsSuccess || setCanAddIsSuccess) {
      dispatch(setLoader(false));
    }
    if (agencyIsError || setCanAddError) {
      dispatch(setLoader(false));
    }
  }, [
    agencyIsLoading,
    agencyIsSuccess,
    agencyIsError,
    setCanAddIsLoading,
    setCanAddError,
    setCanAddIsSuccess,
  ]);

  useEffect(() => {
    if (getUsersIsLoading || getOrdersIsLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [getUsersIsLoading, getOrdersIsLoading]);

  useEffect(() => {
    if (cancelSubscriptionIsSuccess) {
      dispatch(setLoader(false));
    }
    if (cancelSubscriptionIsError) {
      dispatch(setLoader(false));
      setDangerShow(false);
    }
  }, [cancelSubscriptionIsLoading, cancelSubscriptionIsSuccess]);

  useEffect(() => {
    return window.addEventListener('click', e => {
      if (
        e.target.closest('.userSettings') === null &&
        e.target.closest('.management__table-settings') === null
      ) {
        setUserList(old => {
          let newList = [...old];
          return newList.map(el => ({...el, action_status: false}));
        });
        return;
      }
    });
  }, []);

  const changeTab = num => {
    setCurrentTab(num);
    setCurrentPage(1);
  };

  function base64ToBlob(base64Data) {
    const contentType = base64Data.substring(5, base64Data.indexOf(';'));
    const byteCharacters = atob(
      base64Data.substring(base64Data.indexOf(',') + 1),
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const image = base64ToBlob(cropper.getCroppedCanvas().toDataURL());
      setShowModal(false);
      document.querySelector('.modal-fbo').style.display = 'flex';
      setPhoto(cropper.getCroppedCanvas().toDataURL());
      setImageBlob(image);
    }
  };

  const handlePageClick = page => {
    setCurrentPage(page.selected + 1);
    window.scrollTo(0, 0);
  };

  const handleCanAdd = e => {
    setCanAdd(old => ({...old, [e.target.id]: e.target.checked}));
    canAddAction({
      agency_id: params?.id,
      is_able_to_add_facility: e.target.checked ? 1 : 0,
    })
      .unwrap()
      .then(() => {
        getAgency(params.id);
      });
  };

  const renderDangerSubscription = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agencyDetail.modals.cancelSubscription.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDangerShow(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agencyDetail.modals.cancelSubscription.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger third'
              onClick={() => {
                dispatch(setLoader(true));
                cancelSubscription({
                  id: agencyData?.data?.id,
                  data: {cancel_now: true},
                }).then(res => {
                  dispatch(setLoader(false));
                  toast.success(res.data.message);
                  setDangerShow(false);
                  getAgency(params.id);
                });
              }}
            >
              {t('agencyDetail.modals.cancelSubscription.cancelNow')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                dispatch(setLoader(true));
                cancelSubscription({
                  id: agencyData?.data?.id,
                  data: {cancel_now: false},
                }).then(res => {
                  dispatch(setLoader(false));
                  toast.success(res.data.message);
                  setDangerShow(false);
                  getAgency(params.id);
                });
              }}
            >
              {t('agencyDetail.modals.cancelSubscription.cancelAtEnd')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  return (
    <Wrapper>
      {dangerShow && renderDangerSubscription()}
      {showModal && (
        <div className='p-modal'>
          <div className='p-modal__content'>
            <div className='p-modal__header'>
              <p></p>
              <h5 className='p-modal__title'>{t('agencyDetail.modals.cropImage.title')}</h5>
              <div className='p-modal__close'>
                <img
                  src='/assets/icons/close.svg'
                  alt='close'
                  onClick={() => {
                    setShowModal(false);
                    setChosenPhoto(null);
                    document.querySelector('.modal-fbo').style.display = 'flex';
                  }}
                />
              </div>
            </div>
            <div className='p-modal__cropper'>
              <Cropper
                style={{
                  height: 400,
                  width: '100%',
                }}
                zoomTo={0}
                initialAspectRatio={1}
                preview='.img-preview'
                src={chosenPhoto}
                aspectRatio={1}
                viewMode={0}
                minCropBoxHeight={300}
                minCropBoxWidth={300}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                onInitialized={instance => {
                  setCropper(instance);
                }}
                guides={true}
              />
            </div>
            <div className='p-modal__btns'>
              <label
                htmlFor='profile_photo'
                className='profile__imageBox-upload'
              >
                {t('agencyDetail.modals.cropImage.changePhoto')}
              </label>
              <div className='profile__imageBox-upload' onClick={getCropData}>
                {t('agencyDetail.modals.cropImage.savePhoto')}
              </div>
            </div>
          </div>
          <div
            className='p-modal__bg'
            // onClick={() => {
            //   setShowModal(false);
            //   setChosenPhoto(null);
            //   document.querySelector('.modal-fbo').style.display = 'flex'
            // }}
          ></div>
        </div>
      )}
      {createModalStatus && (
        <Modal
          title={t('agencyDetail.modals.createFbo.title')}
          currentItem={agencyData?.data}
          setCurrentItem={setCurrentItem}
          setShowModal={setShowModal}
          setChosenPhoto={setChosenPhoto}
          photo={photo}
          setCreateModalStatus={setCreateModalStatus}
          imageBlob={imageBlob}
          setPhoto={setPhoto}
          type='agancy'
          exit={() => {
            setCreateModalStatus(false);
            setPhoto(null);
            setImageBlob(null);
            setCurrentItem(null);
          }}
          // getAgencies={getAgencies}
          timezones={timezonesData?.data?.map(item => ({
            value: item,
            label: item,
          }))}
          waterKitData={waterKitData?.map(item => ({
            label: item?.name,
            value: item?.id,
          }))}
        />
      )}
      <Helmet>
        <title>{t('agencyDetail.pageTitle')}</title>
      </Helmet>
      <DashboardHeader
        title={t('agencyDetail.title')}
        showBtn={false}
        type='agancy-detail'
      />
      <div className='agencyDetails'>
        <div className='agencyDetails__info'>
          <div className='agencyDetails__info-left'>
            <div className='agencyDetails__info-main'>
              <img
                className='agencyDetails__info-logo'
                src={agencyData?.data?.logo}
                alt='logo'
              />
              <div className='agencyDetails__info-text'>
                <p>{t('agencyDetail.fboName')} </p>
                <p>{agencyData?.data?.title}</p>
              </div>
            </div>
            {/* Region */}
            <p className='agencyDetails__info-info'>
              <span>{t('agencyDetail.region')} </span>
              {agencyData?.data?.region_label ? agencyData?.data?.region_label : '---'}
            </p>
            {/* Airport ID */}
            <p className='agencyDetails__info-info'>
              <span>{t('agencyDetail.airportId')} </span>
              {agencyData?.data?.airport_id
                ? agencyData?.data?.airport_id
                : '---'}
            </p>
            <p className='agencyDetails__info-info'>
              <span>{t('agencyDetail.timezone')} </span>
              {agencyData?.data?.timezone ? agencyData?.data?.timezone : '---'}
            </p>
          </div>
          <div className='agencyDetails__info-right'>
            {/*{*/}
            {/*  agencyData?.data?.subscription_end_date ?*/}
            {/*    <button className="agencyDetails__info-cancel" onClick={() => {*/}
            {/*      setDangerShow(true)*/}
            {/*    }}>Cancel subscription</button>*/}
            {/*    : null*/}
            {/*}*/}
            <button
              className='agencyDetails__info-edit'
              onClick={() => {
                setCreateModalStatus(true);
                setCurrentItem();
              }}
            >
              {t('agencyDetail.edit')}
            </button>
          </div>
        </div>
        <div className='agencyDetails__tabs'>
          <div
            className={`agencyDetails__tab ${currentTab === 0 ? 'active' : ''}`}
            onClick={() => changeTab(0)}
          >
            {t('agencyDetail.tabs.userManagement')}
          </div>
          <div
            className={`agencyDetails__tab ${currentTab === 1 ? 'active' : ''}`}
            onClick={() => changeTab(1)}
          >
            {t('agencyDetail.tabs.subscriptions')}
          </div>
          {(agencyData?.data?.trial_status === 'inspection' ||
            agencyData?.data?.trial_status === 'equipment') && (
            <div
              className={`agencyDetails__tab ${currentTab === 2 ? 'active' : ''}`}
              onClick={() => setCurrentTab(2)}
            >
              {t('agencyDetail.tabs.facilities')}
            </div>
          )}
          {/*<div className={`agencyDetails__tab ${currentTab === 3 ? 'active' : ""}`}*/}
          {/*     onClick={() => changeTab(3)}>Orders*/}
          {/*</div>*/}
        </div>
        {currentTab === 0 ? (
          <div className='agencyDetails__table'>
            <div className='management__table-head'>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.id')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.name')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.email')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.fbo')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.role')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.ein')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.initials')}</div>
              <div className='management__table-th'>{t('agencyDetail.tableHeaders.userManagement.signature')}</div>
              <div className='management__table-th'></div>
            </div>
            <div className='agencyDetails__table-body'>
              {userList?.map(user => (
                <ManagementRow
                  key={user.id}
                  user={user}
                  userAgencyData={agencyData}
                  lengthArray={getUsersData?.length}
                  filteredData={getUsersData}
                  setCurrentUser={setCurrentUser}
                  currentUser={currentUser}
                  userRolesData={userRolesData}
                  setUserList={setUserList}
                  trigerGetUsers={trigerGetUsers}
                  setTrigerGetUsers={setTrigerGetUsers}
                  getUsers={getTrigerUsers}
                />
              ))}
            </div>
          </div>
        ) : currentTab === 1 ? (
          <div className='agencyDetails__table'>
            <div className='profile__history-tableHead'>
              <div className='profile__history-tableTh'>{t('agencyDetail.tableHeaders.subscriptions.startDate')}</div>
              <div className='profile__history-tableTh'>{t('agencyDetail.tableHeaders.subscriptions.endDate')}</div>
              <div className='profile__history-tableTh'>{t('agencyDetail.tableHeaders.subscriptions.subscriptionCost')}</div>
              <div className='profile__history-tableTh'>
                {t('agencyDetail.tableHeaders.subscriptions.invoiceReceipt')}
              </div>
            </div>
            <div className='agencyDetails__table-body'>
              {getSubsData?.data?.length > 0 ? (
                getSubsData?.data?.map(item => (
                  <div
                    className='profile__history-tableBodyRow'
                    key={item?.order_id}
                  >
                    <div className='profile__history-tableBodyTh'>
                      {item?.start_date
                        ? moment(item?.start_date).format('MM/DD/YY')
                        : '---'}
                    </div>
                    <div className='profile__history-tableBodyTh'>
                      {item?.end_date
                        ? moment(item?.end_date).format('MM/DD/YY')
                        : '---'}
                    </div>
                    <div className='profile__history-tableBodyTh'>
                      ${item?.price}
                    </div>
                    <div className='profile__history-tableBodyTh'>
                      {item?.receipt_url ? (
                        <a
                          href={item?.receipt_url}
                          target='_blank'
                          style={{
                            borderRadius: '8px',
                            padding: '8px 27px',
                            fontWeight: 600,
                            color: 'black',
                            background: 'transparent',
                            border: '1.5px solid #8e8e8e',
                          }}
                        >
                          {t('agencyDetail.tableHeaders.subscriptions.view')}
                        </a>
                      ) : (
                        <span>--- ---</span>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '205px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <div className='expired__box-img' style={{margin: '0'}}>
                      <img src='/assets/no-data.svg' alt='no-data' />
                    </div>
                    <p className='no-payment-text'>{t('agencyDetail.messages.noData')}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : currentTab === 2 ? (
          <div>
            {(agencyData?.data?.trial_status === 'equipment' ||
              agencyData?.data?.trial_status === 'inspection') && (
              <div className='agencyDetails__block'>
                <div className='facility-modal__field pl-20'>
                  <Checkbox
                    onChange={handleCanAdd}
                    label={t('agencyDetail.abilityToAddFacilities')}
                    id={'is_able_to_add_facility_trial'}
                    key={'is_able_to_add_facility_trial'}
                    checked={agencyData?.data?.is_able_to_add_facility_trial}
                  />
                </div>
              </div>
            )}
            <div className='agencyDetails__table'>
              <div className='inspectionsForm__table-head invited'>
                <div
                  style={{
                    width: '50%',
                    paddingRight: '0px',
                  }}
                  className='inspectionsForm__table-th'
                >
                  <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.facilities.facilityName')}</span>
                </div>
                <div
                  style={{
                    width: '50%',
                    paddingLeft: '0px',
                    paddingRight: '0px',
                  }}
                  className='inspectionsForm__table-th last'
                >
                  <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.facilities.totalInspections')}</span>
                </div>
              </div>
              <div className='agencyDetails__table-body'>
                {getFacilityByAgencyIdIdData?.data?.length ? (
                  getFacilityByAgencyIdIdData?.data?.map(item => {
                    return (
                      <div className='inspectionsForm__table-row row'>
                        <div
                          style={{width: '50%', paddingRight: '0px'}}
                          className='inspectionsForm__table-bodyTh'
                        >
                          {item?.name}
                        </div>
                        <div
                          style={{
                            width: '50%',
                            paddingRight: '0px',
                            paddingLeft: 0,
                          }}
                          className='inspectionsForm__table-bodyTh last'
                        >
                          {item?.links?.length}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='facility__table-empty'>
                    <img src='/assets/icons/facility-empty.svg' alt='empty' />
                    <p>{t('agencyDetail.messages.noFacilities')}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : currentTab === 3 ? (
          <div className='agencyDetails__table'>
            <div className='inspectionsForm__table-head'>
              <div
                style={{
                  width: '18%',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.id')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.date')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.endDate')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.fbo')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.status')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: ' pointer'}}>{t('agencyDetail.tableHeaders.orders.lastUpdated')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.saleStatus')}</span>
              </div>
              <div
                style={{
                  width: '18%',
                  paddingLeft: '0px',
                  paddingRight: '0px',
                }}
                className='inspectionsForm__table-th'
              >
                <span style={{cursor: 'pointer'}}>{t('agencyDetail.tableHeaders.orders.total')}</span>
              </div>
            </div>

            <div className='agencyDetails__table-body'>
              {getOrdersData?.data?.map(item => (
                <NavLink
                  to={`/orders/${item?.id}`}
                  className='inspectionsForm__table-row'
                  key={item.id}
                  // style={{
                  //   borderColor: ,
                  //   borderWidth: 3,
                  // }}
                >
                  <div
                    style={{width: '18%', paddingRight: '0px'}}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {item?.id}
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {moment(item?.created_at).format('MM/DD/YY')}
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {item?.subscription_end_date ? (
                      moment(item?.subscription_end_date).format('MM/DD/YY')
                    ) : (
                      <span className='status-new'>{t('agencyDetail.tableHeaders.orders.expired')}</span>
                    )}
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {item?.agency_title}
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    <p className={item?.status}>{item?.status}</p>
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {moment(item?.status_updated_at).format('MM/DD/YY')}
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    {'  '}
                    <span
                      className={`${
                        item?.post_sale_status === 'new'
                          ? 'status-new'
                          : item?.post_sale_status === 'seen'
                            ? 'status-seen'
                            : item?.post_sale_status === 'processing'
                              ? 'status-processing'
                              : item?.post_sale_status === 'canceled'
                                ? 'status-canceled'
                                : item?.post_sale_status === 'delivered'
                                  ? 'status-delivered'
                                  : ''
                      }`}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      {item?.post_sale_status ?? '-'}
                    </span>
                  </div>
                  <div
                    style={{
                      width: '18%',
                      paddingLeft: '0px',
                      paddingRight: '0px',
                    }}
                    className='inspectionsForm__table-bodyTh'
                  >
                    $ {item?.total}
                  </div>
                </NavLink>
              ))}
            </div>
          </div>
        ) : null}
      </div>
      {currentTab == 3 ? (
        <CustomPaginate
          pageCount={getOrdersData?.pages}
          handlePageClick={handlePageClick}
        />
      ) : currentTab == 2 ? (
        <CustomPaginate
          pageCount={getFacilityByAgencyIdIdData?.pages}
          handlePageClick={handlePageClick}
        />
      ) : currentTab == 1 ? (
        <CustomPaginate
          pageCount={getSubsData?.pages}
          handlePageClick={handlePageClick}
        />
      ) : null}
    </Wrapper>
  );
};

export default AgencyDetail;
